/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { ITreatmentPlan } from 'app/shared/model/treatment-plan.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { PrescriptionStatus } from 'app/shared/model/enumerations/prescription-status.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IPrescription {
  id?: string;
  tmDate?: number | null;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  patientType?: keyof typeof PatientType | null;
  exposed?: boolean | null;
  approved?: boolean | null;
  status?: keyof typeof PrescriptionStatus | null;
  orderStatus?: keyof typeof OrderStatus | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  issuedBy?: IDoctor;
  patient?: IGlucoUser;
  appointment?: IAppointments | null;
  treatmentPlan?: ITreatmentPlan | null;
  approvedBy?: IDoctor | null;
}

export const defaultValue: Readonly<IPrescription> = {
  active: false,
  exposed: false,
  approved: false,
};
